<template>
  <div class="h-full relative">
    <el-card
      class="h-[calc(100%-66px)] absolute !overflow-visible p-20px left-0 top-66px z-20"
      :body-style="{ height: '100%', padding: '0px', overflow: 'hidden' }"
      :class="leftVisible ? 'w-300px' : 'w-0px !p-0'"
    >
      <div
        class="iconfont icon-line-left absolute -right-24px top-60px bg-hex-$buttonPrimaryBg h-24px w-24px text-hex-$colorLumpText !leading-24px cursor-pointer text-center text-12px z-10"
        @click="setLeftVisible"
      ></div>
      <div>
        <span class="border-l-3 border-color-primary pl-10px text-18px">组件类型</span>
      </div>
      <div class="flex mt-10px mb-10px">
        <el-input
          clearable
          placeholder="组件名称"
          class="flex-1 mr-10px"
          v-model="treeKeyword"
          prefix-icon="el-icon-search"
        />
        <el-button size="small" type="primary" @click="$refs.tree.filter(treeKeyword)"
          >搜索</el-button
        >
      </div>
      <el-tree
        :data="treeData"
        class="h-[calc(100%-77px)] overflow-y-auto"
        :props="{
          label: 'name',
        }"
        highlight-current
        node-key="id"
        :filter-node-method="filterTree"
        v-loading="treeLoading"
        ref="tree"
        ><div
          class="w-full truncate"
          @drag="drag(data)"
          @dragend="dragend(data)"
          draggable="true"
          slot-scope="{ node, data }"
        >
          {{ node.label }}
        </div>
      </el-tree>
    </el-card>
    <div class="relative h-full">
      <el-card :body-style="{ padding: '10px' }">
        <div class="flex justify-between items-center">
          <div class="border-l-3 border-color-primary pl-10px text-18px h-24px leading-24px">
            {{ layoutName }}布局
          </div>
          <div>
            <el-button
              type="primary"
              size="medium"
              class="iconfont icon-save"
              @click="save"
              :loading="saveLoading"
              v-if="queryMode !== 'read'"
              >保存</el-button
            >
            <el-button size="small" class="ml-20px" @click="backup">返回</el-button>
          </div>
        </div>
      </el-card>
      <div
        class="h-[calc(100%-66px)] mt-10px relative"
        id="gridContainer"
        @click.stop="layoutClick"
      >
        <el-card
          class="h-full"
          :body-style="{
            padding: '0px',
            height: '100%',
            overflow: 'hidden auto',
            backgroundSize: `${layoutDetail.gridSize}px ${layoutDetail.gridSize}px`,
          }"
          id="gridContent"
          :class="layoutType === '1' ? 'w-375px m-x-auto' : ''"
        >
          <grid-layout
            :layout.sync="layout"
            :col-num="defaultParams.colNum"
            :row-height="defaultParams.rowHeight"
            :is-draggable="queryMode === 'read' ? false : defaultParams.isDraggable"
            :is-resizable="queryMode === 'read' ? false : defaultParams.isResizable"
            :vertical-compact="defaultParams.verticalCompact"
            :margin="defaultParams.margin"
            :use-css-transforms="true"
            ref="gridlayout"
            style="touch-action: none;"
            :preventCollision="defaultParams.preventCollision"
          >
            <grid-item
              v-for="item in layout"
              :key="item.i"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
              :is-draggable="queryMode === 'read' ? false : item.isDraggable"
              :is-resizable="queryMode === 'read' ? false : item.isResizable"
              :class="{
                'z-10': item.component === 'BayWindow' || item.component === 'NavigationBar',
              }"
              @moved="gridItemMoved"
            >
              <div
                class="h-full"
                :style="{
                  paddingTop: layoutType === '0' ? '0' : '12px',
                }"
              >
                <div
                  class="h-full relative bg-hex-$contentBgColor"
                  @click="clickGridItem(item)"
                  :class="{
                    'grid-item': layoutType === '0',
                  }"
                >
                  <span
                    v-if="item.component !== 'NavigationBar'"
                    class="iconfont icon-line-delete absolute right-0 top-0 z-10 cursor-pointer bg-hex-$portalPrimaryColor text-hex-$portalPrimaryTextColor px-5px"
                    @click.stop="deleteLayoutItem(item)"
                  ></span>
                  <component
                    :is="item.component"
                    :ref="item.i"
                    :i="item.i"
                    :data="item.data"
                    @changeLayout="changeLayout"
                    mode="update"
                  ></component>
                </div>
              </div>
            </grid-item>
          </grid-layout>
        </el-card>
      </div>
    </div>
    <el-card
      class="h-[calc(100%-66px)] absolute !overflow-visible p-20px right-0 top-66px z-20"
      :body-style="{ height: '100%', padding: '0px', overflow: 'hidden' }"
      :class="rightVisible ? 'w-300px' : 'w-0px !p-0'"
    >
      <div
        class="iconfont icon-line-right absolute -left-24px top-60px bg-hex-$buttonPrimaryBg h-24px w-24px text-hex-$colorLumpText !leading-24px cursor-pointer text-center text-12px z-10"
        @click="setRightVisible"
      ></div>
      <div>
        <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">展示设置</span>
      </div>
      <div class="h-[calc(100%-34px)] mt-10px overflow-y-auto overflow-x-hidden">
        <component
          :is="configComponent"
          @configChange="configChange"
          @layoutChange="layoutChange"
          @globalChange="globalChange"
          :configData="currentItem.data"
          :layoutData="currentItem"
          :mode="queryMode === 'read' ? 'view' : 'update'"
          :layoutWidth="defaultParams.colNum"
          :layout="layout"
        ></component>
      </div>
    </el-card>
  </div>
</template>

<script>
import VueGridLayout from 'vue-grid-layout'
import { ColumnPageApi } from '@wiz-api/workbench'
import { generateGUID } from '@/assets/js/Common'
import componetData from '../../js/config'
import appComponentData from '../../js/appConfig'
import exportComponents from '../../js/exportComponents'

const columnPageApi = new ColumnPageApi()
const mouseXY = { x: null, y: null }
let defaultMouseXY = { x: null, y: null }
const DragPos = { x: null, y: null, w: 1, h: 1, i: null }
export default {
  name: 'layoutConfig',
  components: {
    ...exportComponents,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
  },
  data() {
    return {
      saveLoading: false,
      treeKeyword: '',
      treeData: componetData,
      treeLoading: false,
      leftVisible: true,
      rightVisible: true,
      layout: [
        {
          x: (window.innerWidth - 1180) / 2,
          y: 0,
          w: 1180,
          h: 50,
          i: '0',
          isDraggable: false,
          isResizable: false,
          component: 'NavigationBar',
          configComps: 'NavigationBarConfig',
          data: {},
        }, // 默认显示导航
      ], // layout数据
      defaultParams: {
        rowHeight: 1,
        colNum: window.innerWidth,
        isDraggable: true,
        isResizable: true,
        margin: [0, 0],
        verticalCompact: false,
        preventCollision: true,
      }, // layout配置
      configComponent: '', // 展示设置组件
      currentItem: {}, // 当前layout项
      layoutDetail: {
        gridSize: 10,
        windowWidth: window.innerWidth,
      },
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
    // 当前表单类型
    queryMode() {
      return this.$route.query.type
    },
    // 栏目id
    columnId() {
      return this.$route.query.columnId
    },
    // 数据id
    id() {
      return this.$route.query.id
    },
    // 布局类型 0:PC 1:APP
    layoutType() {
      return this.$route.query.layoutType
    },
    // 布局名称
    layoutName() {
      return this.$route.query.name
    },
  },
  methods: {
    changeLayout({ height, i }) {
      this.layout.forEach((item) => {
        if (item.i === i) {
          item.h = height + 12
        }
      })
      this.$refs.gridlayout.layoutUpdate()
    },
    layoutClick(e) {
      // 判断是否点击空白处
      if (e.target.className === 'vue-grid-layout') {
        this.configComponent = 'GlobalConfig'
        this.currentItem = {
          data: {
            gridSize: this.layoutDetail.gridSize,
          },
        }
      }
    },
    // 获取配置详情
    async getLayoutDetail() {
      const [err, res] = await columnPageApi.getColumnPageDetail(this.id)
      if (!err && res.pageDesign) {
        const windowWidth = this.layoutType === '0' ? window.innerWidth : 375
        this.layout = _.map(JSON.parse(res.pageDesign), (item) => {
          if (res.windowWidth > windowWidth) {
            item.x = _.ceil(item.x - (res.windowWidth - windowWidth) / 2)
          } else {
            item.x = _.ceil((windowWidth - res.windowWidth) / 2 + item.x)
          }
          return item
        })
        this.layoutDetail = {
          ...res,
          windowWidth,
          gridSize: res.gridSize || 10,
        }
      }
    },
    // 保存
    async save() {
      let api = null
      const windowWidth = this.layoutType === '0' ? window.innerWidth : 375
      const body = {
        columnId: this.columnId,
        pageDesign: JSON.stringify(this.layout),
        name: this.layoutName,
        isActive: this.layoutDetail.isActive,
        gridSize: this.layoutDetail.gridSize,
        windowWidth,
        type: this.layoutType,
      }
      if (this.queryMode === 'create') {
        body.isActive = false
        api = await columnPageApi.addColumnPage({
          body,
        })
      } else {
        body.id = this.id
        api = await columnPageApi.updateColumnPage({
          body,
        })
      }
      if (!api[0]) {
        this.$message.success('保存成功!')
        if (this.queryMode === 'create') {
          this.$router.replace({
            path: `${this.routerBase}/layout/layout-config`,
            query: {
              type: 'update',
              layoutType: this.layoutType,
              columnId: api[1].columnId,
              name: this.layoutName,
              id: api[1].id,
            },
          })
          this.getLayoutDetail()
        }
      }
    },
    // 返回
    backup() {
      // this.$router.push('/portal-management/portal-config/layout-management')
      this.$router.go(-1)
    },
    filterTree(value, data) {
      return data.name.includes(value)
    },
    setLeftVisible() {
      this.leftVisible = !this.leftVisible
    },
    setRightVisible() {
      this.rightVisible = !this.rightVisible
    },
    drag(data) {
      // 判断查看或未拖动
      if (this.queryMode === 'read' || _.isEqual(defaultMouseXY, mouseXY)) return
      defaultMouseXY = _.cloneDeep(mouseXY)
      const parentRect = document.getElementById('gridContent').getBoundingClientRect()
      let mouseInGrid = false
      // pc布局要加上左侧组件类型面板
      const gridLeft = this.layoutType === '0' ? parentRect.left + 300 : parentRect.left
      if (
        mouseXY.x > gridLeft &&
        mouseXY.x < parentRect.right &&
        mouseXY.y > parentRect.top &&
        mouseXY.y < parentRect.bottom
      ) {
        mouseInGrid = true
      }
      if (
        mouseInGrid &&
        this.layout.findIndex((item) => {
          return item.i === 'drop'
        }) === -1
      ) {
        const gridCard = document.getElementById('gridContent').children[0]
        const scrollTop = mouseXY.y - parentRect.top + gridCard.scrollTop
        const scrollLeft =
          mouseXY.x - parentRect.left > parentRect.right - data.config.w
            ? parentRect.right - data.config.w
            : mouseXY.x - parentRect.left
        // 获取拖拽元素四个角坐标
        const dropRange = {
          x: scrollLeft,
          y: scrollTop,
          x1: scrollLeft + data.config.w,
          y1: scrollTop + data.config.h,
        }
        // 判断拖拽元素是否与布局元素碰撞
        if (this.layoutType === '0') {
          const isInRange = _.findIndex(this.layout, (item) => {
            const xInRange =
              (dropRange.x >= item.x && dropRange.x <= item.x + item.w) ||
              (dropRange.x1 >= item.x && dropRange.x1 <= item.x + item.w) ||
              (item.x >= dropRange.x && item.x <= dropRange.x1) ||
              (item.x + item.w >= dropRange.x && item.x + item.w <= dropRange.x1)
            const yInRange =
              (dropRange.y >= item.y && dropRange.y <= item.y + item.h) ||
              (dropRange.y1 >= item.y && dropRange.y1 <= item.y + item.h) ||
              (item.y >= dropRange.y && item.y <= dropRange.y1) ||
              (item.y + item.h >= dropRange.y && item.y + item.h <= dropRange.y1)
            return xInRange && yInRange
          })
          if (isInRange > -1) return
        }
        this.layout.push({
          x: scrollLeft,
          y: scrollTop,
          w: data.config.w,
          h: data.config.h,
          i: 'drop',
        })
      }
      const index = this.layout.findIndex((item) => {
        return item.i === 'drop'
      })
      if (index !== -1) {
        try {
          this.$refs.gridlayout.$children[this.layout.length].$refs.item.style.display = 'none'
        } catch {
          //
        }
        const gridCard = document.getElementById('gridContent').children[0]
        const el = this.$refs.gridlayout.$children[index]
        const scrollTop = mouseXY.y - parentRect.top + gridCard.scrollTop
        const scrollLeft =
          mouseXY.x - parentRect.left > parentRect.right - data.config.w
            ? parentRect.right - data.config.w
            : mouseXY.x - parentRect.left
        el.dragging = {
          top: scrollTop,
          left: scrollLeft,
        }
        // const newPos = el.calcXY(scrollTop, scrollLeft)
        if (mouseInGrid === true) {
          this.$refs.gridlayout.dragEvent(
            'dragstart',
            'drop',
            scrollLeft,
            scrollTop,
            data.config.h,
            data.config.w
          )
          DragPos.i = generateGUID()
          DragPos.x = this.layout[index].x
          DragPos.y = this.layout[index].y
        }
        if (mouseInGrid === false) {
          this.$refs.gridlayout.dragEvent(
            'dragend',
            'drop',
            scrollLeft,
            scrollTop,
            data.config.h,
            data.config.w
          )
          this.layout = this.layout.filter((obj) => {
            return obj.i !== 'drop'
          })
        }
      }
    },
    dragend(data) {
      const lodeMoreItem = _.find(this.layout, { component: 'AppLoadMore' })
      if (lodeMoreItem && data.config.componentName === 'AppLoadMore') {
        this.$message.warning('只能存在一个下拉加载组件!')
        this.layout = this.layout.filter((obj) => {
          return obj.i !== 'drop'
        })
        return
      }
      const parentRect = document.getElementById('gridContent').getBoundingClientRect()
      let mouseInGrid = false
      // pc布局要加上左侧组件类型面板
      const gridLeft = this.layoutType === '0' ? parentRect.left + 300 : parentRect.left
      if (
        mouseXY.x > gridLeft &&
        mouseXY.x < parentRect.right &&
        mouseXY.y > parentRect.top &&
        mouseXY.y < parentRect.bottom
      ) {
        mouseInGrid = true
      }
      mouseXY.x = null
      mouseXY.y = null
      const index = this.layout.findIndex((item) => {
        return item.i === 'drop'
      })
      if (mouseInGrid && index !== -1) {
        this.$refs.gridlayout.dragEvent('dragend', 'drop', DragPos.x, DragPos.y, 2, data.config.w)
        this.layout = this.layout.filter((obj) => {
          return obj.i !== 'drop'
        })
        const layoutItem = {
          x: DragPos.x,
          y: DragPos.y,
          w: data.config.w,
          h: data.config.h,
          i: DragPos.i,
          isDraggable: data.config.isDraggable || false,
          component: data.config.componentName,
          configComps: data.config.configName,
          type: data.config.type,
          data: {},
        }
        if (layoutItem.component === 'Breadcrumb') {
          layoutItem.data = {
            dataSource: this.columnId,
          }
        }
        this.layout.push(layoutItem)
        this.$refs.gridlayout.dragEvent(
          'dragend',
          DragPos.i,
          DragPos.x,
          DragPos.y,
          2,
          data.config.w
        )
        this.configComponent = data.config.configName
        this.currentItem = _.cloneDeep(this.layout.at(-1))
        try {
          this.$refs.gridlayout.$children[this.layout.length].$refs.item.style.display = 'block'
        } catch {
          //
        }
      }
    },
    dragover(e) {
      mouseXY.x = e.clientX
      mouseXY.y = e.clientY
    },
    gridItemMoved() {
      if (this.layoutType === '0') return
      this.$nextTick(() => {
        const lastItem = _.maxBy(this.layout, 'y')
        const loadMoreItemIndex = _.findIndex(this.layout, { component: 'AppLoadMore' })
        if (lastItem.component !== 'AppLoadMore' && loadMoreItemIndex !== -1) {
          this.$message.warning('下拉加载组件只能为最后一个组件!')
          const layoutItem = this.layout[loadMoreItemIndex]
          layoutItem.y = lastItem.y + lastItem.h
          this.$refs.gridlayout.layoutUpdate()
        }
      })
    },
    // layout组件点击
    clickGridItem(item) {
      this.currentItem = _.cloneDeep(item)
      this.configComponent = item.configComps
    },
    deleteLayoutItem(item) {
      this.layout = _.differenceWith(this.layout, [item], _.isEqual)
    },
    // 展示设置组件参数修改
    configChange(data) {
      console.log('data', data)
      const layoutItem = _.find(this.layout, { i: this.currentItem.i })
      if (layoutItem) {
        layoutItem.data = _.cloneDeep(data)
      }
      this.currentItem = _.cloneDeep(layoutItem)
    },
    // 展示设置layout修改
    layoutChange(val) {
      const layoutItem = _.find(this.layout, { i: this.currentItem.i })
      if (layoutItem) {
        _.assign(layoutItem, val)
      }
      if (this.layoutType === '1') {
        const gridLayout = this.$refs.gridlayout
        gridLayout.layouts.xxs = _.cloneDeep(this.layout)
        gridLayout.layoutUpdate()
      }
    },
    // 全局设置修改
    globalChange(val) {
      _.assign(this.layoutDetail, val)
    },
  },
  created() {
    const windowWidth = this.layoutType === '0' ? window.innerWidth : 375
    if (this.layoutType === '1') {
      this.layout = []
      this.defaultParams.colNum = windowWidth
      this.defaultParams.verticalCompact = true
      this.defaultParams.preventCollision = false
      this.defaultParams.colNum = windowWidth
      this.layoutDetail.windowWidth = windowWidth
      this.treeData = appComponentData
    }
    if (this.id) {
      this.getLayoutDetail()
    }
  },
  mounted() {
    document.addEventListener('dragover', this.dragover, false)
    const gridLayout = this.$refs.gridlayout
    if (gridLayout) {
      gridLayout.updateHeight = () => {
        const height = gridLayout.containerHeight()
        gridLayout.mergedStyle = {
          height: `${+height.replace('px', '') + 300}px`,
        }
      }
    }
    window.onresize = () => {
      const windowWidth = this.layoutType === '0' ? window.innerWidth : 375
      this.defaultParams.colNum = windowWidth
      this.layout = _.map(this.layout, (item) => {
        if (this.layoutDetail.windowWidth > windowWidth) {
          item.x = _.ceil(item.x - (this.layoutDetail.windowWidth - windowWidth) / 2)
        } else {
          item.x = _.ceil((windowWidth - this.layoutDetail.windowWidth) / 2 + item.x)
        }
        return item
      })
      this.layoutDetail.windowWidth = windowWidth
    }
  },
  beforeDestroy() {
    document.removeEventListener('dragover', this.dragover)
  },
  deactivated() {
    document.removeEventListener('dragover', this.dragover)
  },
}
</script>

<style lang="scss" scoped>
.grid-item {
  border: 1px solid var(--lineBorderColor);
}
#gridContent {
  ::v-deep .el-card__body {
    background-image: linear-gradient(to right, var(--lineBorderColor) 1px, transparent 1px),
      linear-gradient(to bottom, var(--lineBorderColor) 1px, transparent 1px);
    background-repeat: repeat;
  }
}
::v-deep .vue-grid-item > .vue-resizable-handle {
  z-index: 10;
}
</style>
